import { Outlet } from 'react-router-dom'

import { PageHeader } from '@/components/common/navigation/PageHeader'

export default function Component({ isSale }: { isSale: boolean }) {
  return (
    <>
      <PageHeader title={isSale ? 'Ordens de venda' : 'Ordens de serviço'} />
      <Outlet />
    </>
  )
}
